import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { rmsUL } from './delivery/rms-ul.config';
import { rmsLegacy } from './delivery/rms-legacy.config';
import { commandUL } from './delivery/command-ul.config';
import { arkikUL } from './delivery/arkik-ul.config';

export const readymix = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: {
    [ORDER_EXPERIENCES.RMX_LEGACY]: rmsLegacy,
    [ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK]: rmsUL,
    [ORDER_EXPERIENCES.COMMAND_UNIVERSAL_LINK]: commandUL,
    [ORDER_EXPERIENCES.ARKIK_UNIVERSAL_LINK]: arkikUL,
  },
};
